import type { EventType } from '../../enums';

type OmitEvent<P extends object> = P extends { event: unknown } ? never : P;

export const createEventCreator =
  <E extends EventType>(event: E) =>
  <P extends object>(eventPayload: OmitEvent<P>): P & { event: E } => ({
    event,
    ...eventPayload,
  });
